module.exports = __webpack_public_path__ + "static/img/RiskScanBg.c46d9180.png";